import React, { useState, useEffect } from "react";
import "./ExploreCategory.css";
import Common_Title_2 from "../../common-components/common_title_2/Common_Title_2";
import { getCategories } from "../../../utils/apis/homepage";
import { IDS } from "../../../utils/common";
import { Link } from "react-router-dom";

const categories = [
  {
    id: 1,
    name: "Water Soluble Fertilizer",
    image: "/assets/images/home/explorecategory/watersoluble_fertilizer.jpeg",
  },
  {
    id: 2,
    name: "Liquid Nutrition",
    image: "/assets/images/products/fertilizer/npk fertilizer.png",
  },
  {
    id: 3,
    name: "MicroNutrients",
    image: "/assets/images/products/fertilizer/liquid fertilizer.png",
  },
  {
    id: 4,
    name: "Bio Products",
    image: "/assets/images/products/fertilizer/fertilizer1.png",
  },
];

const ExploreCategory = () => {
  const [banner, setBanner] = useState([]);

  const getBanner = async () => {
    const res = await getCategories();
    if (res?.success) setBanner(res.data);
  };

  useEffect(() => {
    getBanner();
  }, []);

  return (
    <section className="explore_category">
      <div className="container">
        <div className="section_heading">
          <Common_Title_2
            titleText="Explore Categories"
            subText="Complete agricultural solutions for healthier crops and higher yields"
          />
        </div>

     <div className="row justify-content-center">
  {banner?.map((item) => (
    <div className="col-lg col-md-3 col-6" key={item.id}>
    <Link
  to={`/products/${item.name
    ?.toLowerCase()
    .trim()
    .replace(/\s+/g, "")}`}
  className="category_card_link"
>
  <div className="category_card">
    <div className="category_image">
      <img
        src={IDS?.IMG_URL + item.image}
        alt={item.name}
      />
    </div>

    <h5>{item.name}</h5>
  </div>
</Link>
    </div>
  ))}
</div>
      </div>
    </section>
  );
};

export default ExploreCategory;
